import { httpPost } from './apiService';
import { ArticleEntityAdminService } from './articleEntityAdminService';
import { BlogArticle } from '@models/blog';

export class BlogAdminService extends ArticleEntityAdminService<BlogArticle> {
    constructor() {
        super('/api/admin/blog');
    }

    async migrateAuthorArticles(sourceAuthorId: number, targetAuthorId: number): Promise<void> {
        const response = await httpPost(`${this.baseUrl}/migrate-blog/${sourceAuthorId}/${targetAuthorId}`);
        return this.returnResult<void>(await response.json());
    }
}
